define('ajaxOffers',[
  'jquery',
  'lib/util/tda.config',
  'lib/getParameterByName',
  'ajaxComponent',
  'lib/transforms/offers.tmpl.common',
], function (
  $,
  tdaConfig,
  getParameterByName,
  AjaxComponent,
  xformOffersCommon
) {
  // extends AjaxComponent
  var AjaxOffers = function AjaxOffers(serviceUrl, serviceParams, CACHE_IDS, $template) {
    var appKey = 'key=' + tdaConfig.offers.r2_api_key;
    var tdaCode = '&tdaCode=' + tdaConfig.tda.code;
    var exists = arguments[0].indexOf(tdaCode);
    if (exists === -1) {
      arguments[0] = arguments[0] + tdaCode;
    }

    if (getParameterByName('effectiveDate') !== '') {
      arguments[0] = arguments[0] + '&effectiveDate=' + getParameterByName('effectiveDate');
    }
    if (arguments[0].indexOf(appKey) === -1) { // multiple instances of the key cause offers service to fail
      arguments[0] = arguments[0] + '&' + appKey;
    }
    AjaxComponent.apply(this, arguments); // super();

    this.startString = '&startIndex=';
    this.seriesString = '&series=';
    this.addEventListeners();
  };

  AjaxOffers.prototype = new AjaxComponent();
  AjaxOffers.prototype.constructor = AjaxOffers;

  AjaxOffers.prototype.parseData = function (data) {
    var self = this;
    var featured = getParameterByName('featured');
    xformOffersCommon(data.offerBundle.offers)
      .then(function (offers) {

        // If it's not already cached in DOM (as seen in old XFORM that needed to be pulled out)
        // then we can add it
        offers.map(function (offer) { // eslint-disable-line array-callback-return
          if (!self.isCached(offer.id) && !!offer.id) {
            self.cachedIds.push(offer.id);
            self.data.items.push(offer);
          }
        });

        // ensure featured Offers only returns first offer
        // this is pretty bad, as it affects ALL offer calls
        // not the instance of a particular offer call
        if (featured) {
          self.data.numFound = 1;
        } else {
          self.data.numFound = data.totalOffers;
        }

        self.handlebarsData();

        // for analytics on Vehicle-OffersPage
        // this is duplicated in filters.js. Offers-VehiclePage loads ajax from
        // filters.js first, then uses this one for the following filters ajax calls
        // console.log("check for vehicles offer page");
        // TODO move to vehicle offers specific JS
        if ($('#offers-vehicle-page').length > 0) {
          var allCheckedInputs = $('input:checked');
          $('.filters').find(allCheckedInputs).map(function () {
            return $(this).attr('data-name');
          }).get()
            .join(',');

          var numFound = $('.total-found').html();
          if (numFound == '') {
            numFound = self.data.items.length;
          }
        }

        if ($('.isotope-container').height() > 0) {
          $('#no-offers-found').hide();
          $('#showing-number-of-total').show();
        }
      });
  };

  return AjaxOffers;
});

